export const LogicOperatorOptions = [
  {
    name: '>',
    value: '>',
  },
  {
    name: '<',
    value: '<',
  },
  {
    name: '>=',
    value: '>=',
  },
  {
    name: '=<',
    value: '=<',
  },
  {
    name: 'not equals',
    value: '!=',
  },
  {
    name: 'equals',
    value: '=',
  },
  {
    name: 'empty',
    value: 'empty',
  },
  {
    name: 'not empty',
    value: '!empty',
  },
  {
    name: 'contains',
    value: 'contains',
  },
  {
    name: 'not contains',
    value: '!contains',
  },
];

type ConditionType = {
  question: string;
  logic: string;
  logicOperator: string;
  equals: string;
};

export const generateCondition = (arr: ConditionType[]) => {
  const conditionArray: string[] = [];

  arr.forEach(({ logic, question, logicOperator, equals }, index: number) => {
    const isFirstElem = index === 0;
    if (isFirstElem) {
      conditionArray.push(`({${question}}`);
      conditionArray.push(logicOperator);
      conditionArray.push(`${equals})`);
    } else {
      conditionArray.push(logic);
      conditionArray.push(`({${question}}`);
      conditionArray.push(logicOperator);
      conditionArray.push(`${equals})`);
    }
  });

  return conditionArray.join(' ');
};

export const reverseGenerateCondition = (string: string) => {
  if (!string) return [];

  const withoutBrackets = string.replace(/\(/g, '').replace(/\)/g, '');
  const splited = withoutBrackets.split(' ');
  const divided = [splited.splice(0, 3)];
  const reversed: any = [];

  for (let i = 0, j = splited.length; i < j; i += 4) {
    const spliced = splited.slice(i, i + 4);

    divided.push(spliced);
  }

  divided.forEach((arr, index) => {
    const isFirstElem = index === 0;

    if (isFirstElem) {
      reversed.push({
        question: arr[0].replace(/[{()}]/g, ''),
        logic: null,
        logicOperator: arr[1],
        equals: arr[2],
      });
    } else {
      const adjusted: any = {
        logic: arr[0],
        question: arr[1].replace(/[{()}]/g, ''),
        logicOperator: arr[2],
        equals: arr[3],
      };

      reversed.push(adjusted);
    }
  });

  return reversed;
};
